module.exports = __webpack_public_path__ + "img/2.0c4fe1b5.png";